<template>
    <rkm-form ref="RkmForm">
        <rkm-overlay :show="loading">
            <tabs-custom
                :abas="model.abas"
                :initialData="{id: null, texto: ''}"
            >
                <template #tab-content="{aba}">
                    <rkm-form-text-editor
                        class="xxx"
                        name="manual"
                        v-model="aba.texto"
                    />
                </template>
            </tabs-custom>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Components.
import TabsCustom from '@/components/base/TabsCustom'

// Mixins.
import {error, notification} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {TabsCustom},
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-funcionalidade-form')
        },
        validations() {
            return {}
        },
    },
    data: () => ({
        model: {
            sistema_nome: null,
            modulo_nome: null,
            funcionalidade_nome: null,
            funcionalidade_identificador: null,
            abas: [],
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (this.id) {
                this.setLoading('cadastro-funcionalidade-form')

                this.repositories.cadastro.funcionalidade.edit(this.id)
                    .then(({data}) => this.model = data.model)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-funcionalidade-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        if (this.model.abas.some(a => !!a.editing)) {
                            this.showWarningNotification('Atenção', 'Finalize a alteração dos nomes das abas antes de salvar.')

                            return
                        }

                        this.setLoading('cadastro-funcionalidade-form')

                        const request = {
                            abas: this.model.abas.map(aba => ({id: aba.id, nome: aba.title, texto: aba.texto}))
                        }

                        this.repositories.cadastro.funcionalidade.update(request, this.id)
                            .then(({data}) => this.$emit('save', data))
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('cadastro-funcionalidade-form'))
                    }
                })
        },
    },
    mixins: [error, notification],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>

<style scoped>
.xxx >>> .ql-editor {
    overflow-wrap: anywhere;
}
</style>